<!-- Events -->
<!-- itemCreated -->

<template>
  <base-sq-card>
    <template v-slot:heading>
      <span class="tile-card-heading">Payments</span>
      <v-spacer></v-spacer>
      <base-btn-menu
        v-if="isStaff"
        icon="mdi-dots-vertical"
      >
        <v-list>
          <v-list-item
            link
            @click="doGetObjects"
          >
            <v-list-item-title>
              <v-icon
                color="blue darken-1"
                class="mr-1"
              >
                mdi-refresh
              </v-icon>

              Refresh
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </base-btn-menu>
    </template>
    <v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="5"
        :options.sync="options"
        :server-items-length="totalRecords"
        :loading="loading"
        fixed-header
        item-key="rowkey"
        height="350px"
      >
        <template v-slot:item._action="{ item }">
          <base-btn-menu>
            <v-list>
              <v-list-item
                link
                :href="'/#/public-reporting/payment-receipt?account=' + selectedAccount.rowkey + '&payment=' + item.pmt_id"
                :target="'_blank'"
              >
                <v-list-item-title>
                  <v-icon
                    color="blue darken-1"
                    class="mr-1"
                  >
                    mdi-file-find
                  </v-icon>

                  Preview
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </base-btn-menu>
        </template>
        <template v-slot:item.pmt_date="{ item }">
          {{ formatDate(item.pmt_date) }}
        </template>
        <template v-slot:item.pt_name="{ item }">
          {{ getPaymentMethodString(item) }}
        </template>
      </v-data-table>
    </v-row>
    <v-overlay
      :value="overlayDisplay"
      :absolute="overlayAbsolute"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </base-sq-card>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_PAYMENTS,
    ACCT_GET_ACCOUNT_INVOICES,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'PowAccountPayments',

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        totalRecords: 0,
        loading: false,
        options: {},
        items: [],
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          { text: '', value: '_action' },
          { text: 'Id', value: 'pmt_id' },
          {
            text: 'Date',
            align: 'start',
            sortable: false,
            value: 'pmt_date',
          },
          { text: 'Amount', value: 'pmt_total' },
          { text: 'Method', value: 'pt_name' },
        ],
      }
    },

    computed: {
      ...mapGetters({
        // items: 'selectedAccountCorrespondences',
        selectedAccount: 'acctSelectedAccount',
      }),
    },
    watch: {
      options: {
        handler (val, oldVal) {
          console.log('table options changed:', val)
          this.doGetObjects()
        },
        deep: true,
      },
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getInvoices: ACCT_GET_ACCOUNT_INVOICES,
        queryPayments: ACCT_GET_ACCOUNT_PAYMENTS,
      }),
      async init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.formMode = 'read'
        this.overlayDisplay = true
        await this.doGetObjects()
        this.overlayDisplay = false
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      getPaymentMethodString (item) {
        let string = ''
        string += item.pt_name
        if (item.pmt_number_masked && item.pmt_number_masked.length > 0) {
          string += `(*${item.pmt_number_masked})`
        }
        return string
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      async doGetObjects () {
        if (this.loading || this.selectedAccount.rowkey === '' || !this.selectedAccount.rowkey) return
        this.loading = true
        try {
          const queryPayload = {
            page: this.options.page,
            pageSize: this.options.itemsPerPage,
          }
          // eslint-disable-next-line camelcase
          const { total_count, items } = await this.queryPayments(queryPayload)
          this.items = items
          // eslint-disable-next-line camelcase
          this.totalRecords = total_count
        } catch (e) {
          this.loading = false
        }
        this.loading = false
      },
    },

  }
</script>

<style>
</style>
